import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 57F5D624-D5B0-4F19-AFAB-676F822C87DC
 * name arrow-left-circle
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowLeftCircleIcon = createSvgIcon(<><path d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M18,11H10L13.5,7.5L12.08,6.08L6.16,12L12.08,17.92L13.5,16.5L10,13H18V11Z" /></>, 'ArrowLeftCircleIcon');
export default ArrowLeftCircleIcon